export const VERIFICATION_PRE_SORTIE_TEXT =
  process.env.REACT_APP_VERIFICATION_INFO_PROPRIETAIRE_PRE_SORTIE_TEXT || '';

export const VERIFICATION_PRE_SORTIE_CHECKBOX_TEXT =
  process.env
    .REACT_APP_VERIFICATION_INFO_PROPRIETAIRE_PRE_SORTIE_CHECKBOX_TEXT || '';
